import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp, css } from 'styled-components';
import { DocumentStatus } from 'types/documentsService';

export interface DocumentCardStylings {
  $status: DocumentStatus;
}

const statusColorMap: Record<DocumentStatus, string> = {
  [DocumentStatus.INACTIVE]: colors.neutral[300],
  [DocumentStatus.BYPASSED]: colors.neutral[300],
  [DocumentStatus.NOT_UPLOADED]: colors.red[600],
  [DocumentStatus.UPLOADED]: colors.yellow[300],
  [DocumentStatus.REJECTED]: colors.red[600],
  [DocumentStatus.APPROVED]: colors.green[600],
  [DocumentStatus.SIGNATURE_PENDING]: colors.orange[600],
  [DocumentStatus.SIGNATURE_REQUEST_FAILED]: colors.red[600],
  [DocumentStatus.SIGNED]: colors.indigo[600],
};

export const TagStyled = styled.span<DocumentCardStylings>`
  background-color: ${colors.red[600]};
  color: ${colors.neutral.white};
  border-radius: 14px;
  min-width: 12rem;
  text-align: center;
  padding: 0.5rem;
  height: fit-content;
  font-size: 1.4rem;
  line-height: 2rem;
  ${({ $status }): CSSProp =>
    css`
      background-color: ${statusColorMap[$status]};
    `}

  ${({ $status }): CSSProp => {
    switch ($status) {
      case DocumentStatus.UPLOADED:
      case DocumentStatus.BYPASSED:
        return css`
          color: ${colors.neutral.black};
        `;

      default:
        return css`
          color: ${colors.neutral.white};
        `;
    }
  }}
`;
